import React, { Component, Fragment, useEffect, useState } from 'react';
import { View, Alert, ActivityIndicator } from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { Creators as userActions } from '../store/ducks/user';
import { Creators as toastAcitons } from '../store/ducks/toast';
import { Creators as pedidosActions } from '../store/ducks/pedidos';
import { Creators as pedidoSelecionadoActions } from '../store/ducks/pedido-selecionado';

import AppsNavigator from './AppsNavigator';
import Login from '../screens/login';

import { isSignedIn, getUserDetails } from '../config/Auth';
import { configureEnv } from '../services/Api';
import Colors from '../config/Colors';
import { deleteAllCookies } from '../config/Cookies';

import WebsocketController from '../components/websocket';

function MainNavigator({
    userAdd,
    addToast,
    userRemove,
    clearPedidos,
    deselectPedido,
    user
}) {
    const [signedIn, setSignedIn] = useState(false);
    const [checkedSignIn, setCheckedSignIn] = useState(false);

    const onLoginSuccess = ({ token }) => {
        configureEnv({ onLogout: onLogout }).then(() => {
            getUserDetails(token).then((user) => {
                userAdd(user);
                setSignedIn(true);
            });
        });
    };

    const onLogout = () => {
        return new Promise(async (resolve, reject) => {
            if (await AsyncStorage.getItem('token')) {
                await AsyncStorage.clear();
                userRemove();
                clearPedidos();
                deselectPedido();
                deleteAllCookies();
                setSignedIn(false);
                resolve(true);
            } else {
                resolve(true);
            }
        });
    };

    useEffect(() => {
        isSignedIn()
            .then((res) => {
                setSignedIn(res);
                setCheckedSignIn(true);
            })
            .catch(() => {
                Alert.alert('Não foi possível verificar as credenciais');
                setSignedIn(false);
                setCheckedSignIn(true);
            });
    }, []);

    if (!checkedSignIn) {
        return (
            <View
                style={{
                    flex: 1,
                    backgroundColor: Colors.secondary,
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <ActivityIndicator size="large" color={Colors.white} />
            </View>
        );
    }

    if (user !== null && signedIn) {
        return (
            <Fragment>
                <WebsocketController />
                <AppsNavigator />
            </Fragment>
        );
    }

    return <Login onLoginSuccess={onLoginSuccess} />;
}

const mapStateToProps = ({ user }) => ({
    user
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...userActions,
            ...pedidosActions,
            ...pedidoSelecionadoActions,
            ...toastAcitons
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MainNavigator);
